import { QueryFactory } from "../../../../Common";
export const QGetCashOutOperations = QueryFactory("GetCashOutOperations");
//# sourceMappingURL=GetCashOutOperations.js.map